/*
 * bk-media-presson-ladder-fix.js
 * ------------------------------------------------------------------
 * Korrigiert Slot-Badges und Slot-Stückpreise der Gratis-Ladder für
 * Press-On-Bundles. Die Original-Funktionen in bk-media.js enthalten
 * eine fest verdrahtete UV-Folien-Tabelle (25 % / 50 % / GRATIS), die
 * für Press-Ons falsche Werte anzeigt (8,00 € / -50 % statt der
 * echten Marginalpreise 12,50 € / -21 % bzw. 10,00 € / -37 %).
 *
 * Ansatz: Press-On-Gruppen (bundleGroup enthält 'presson') rechnen
 * den Rabatt aus der Zahl-Leiter: pay(n) - pay(n-1) gegen den
 * Einzelpreis. Alle anderen Gruppen (UV) delegieren unverändert an
 * die Originale – UV-Verhalten bleibt byte-identisch.
 *
 * Badge-Label wird IMMER abgerundet (21,875 % -> 21 %), damit der
 * ausgewiesene Rabatt nie höher ist als der tatsächliche (PAngV).
 * Der Stückpreis rechnet mit dem exakten Prozentsatz, damit
 * 12,50 € / 10,00 € erscheinen und nicht gerundete Näherungen.
 *
 * Zusätzlich (Abschnitt 2): ergänzt auf den Slot-Kacheln Form und
 * Länge des Designs (z. B. „Berry Cherry · Medium Almond“), damit
 * gleichnamige Designs mit unterschiedlicher Form unterscheidbar
 * sind. Quelle: presson_meta aus dem Produkt-Mini-JSON (Metafeld
 * custom.presson_details bzw. laenge-/form-Tags), Fallback:
 * Handle-Tokens. UV-Produkte liefern kein Meta und bleiben unberührt.
 *
 * MUSS nach bk-media.js geladen werden (beide defer -> Reihenfolge
 * in layout/theme.liquid).
 * ------------------------------------------------------------------
 */
(function () {
  var origBadge = window.bkMediaBundleGratisLadderBadgeForDesign;
  var origPct = window.bkMediaBundleGratisLadderBadgeForDesignDiscountPct;
  var origUnitAfter = window.bkMediaBundleUnitPriceAfterBadgeDiscountPct;
  var marginalSave = window.bkMediaBundleMarginalAddonSaveCents;

  if (typeof origBadge !== 'function' || typeof origPct !== 'function' || typeof marginalSave !== 'function') {
    return;
  }

  function isPressOnLadder(cfg) {
    if (!cfg || cfg.gratisStarterLadder !== true) return false;
    return String(cfg.bundleGroup || '').indexOf('presson') !== -1;
  }

  /* Exakter Rabatt in % für Design Nr. dn, aus der Zahl-Leiter. */
  function marginalPctExact(dn, cfg) {
    var u = Math.round(Number(cfg.addonUnitPrice) || 0);
    if (u <= 0) return 0;
    var save = marginalSave(dn, cfg);
    if (!(save > 0)) return 0;
    return 100 * save / u;
  }

  window.bkMediaBundleGratisLadderBadgeForDesign = function (designNum, n, tierQty, cfg, gratisHtml, discountHtml) {
    if (!isPressOnLadder(cfg)) {
      return origBadge(designNum, n, tierQty, cfg, gratisHtml, discountHtml);
    }
    var dn = Math.floor(Number(designNum));
    var nz = Math.floor(Number(n));
    var tq = Math.floor(Number(tierQty) || 0);
    if (!isFinite(dn) || !isFinite(nz) || dn < 1) return '';
    if (dn <= tq || dn > nz) return '';
    var p = marginalPctExact(dn, cfg);
    if (p > 0) return discountHtml(Math.floor(p));
    return '';
  };

  window.bkMediaBundleGratisLadderBadgeForDesignDiscountPct = function (designNum, n, tierQty, cfg) {
    if (!isPressOnLadder(cfg)) {
      return origPct(designNum, n, tierQty, cfg);
    }
    var dn = Math.floor(Number(designNum));
    var nz = Math.floor(Number(n));
    var tq = Math.floor(Number(tierQty) || 0);
    if (!isFinite(dn) || !isFinite(nz) || dn < 1) return null;
    if (dn <= tq || dn > nz) return null;
    var p = marginalPctExact(dn, cfg);
    return p > 0 ? p : null;
  };

  /*
   * Stückpreis aus Prozentsatz: Original floor()t den Prozentsatz auf
   * ganze Zahlen (21,875 -> 21 -> 12,64 €). Für gebrochene Prozentsätze
   * exakt rechnen (-> 12,50 €). Ganzzahlige Prozentsätze (UV: 25, 50)
   * laufen unverändert durchs Original.
   */
  window.bkMediaBundleUnitPriceAfterBadgeDiscountPct = function (fullUnitCents, pct) {
    var u = Math.round(Number(fullUnitCents) || 0);
    var p = Number(pct);
    if (u <= 0 || !isFinite(p) || p <= 0) return u;
    if (p >= 100) return 0;
    if (Math.abs(p - Math.floor(p)) < 1e-9 && typeof origUnitAfter === 'function') {
      return origUnitAfter(fullUnitCents, pct);
    }
    var discountAmt = Math.round(u * p / 100);
    return Math.max(0, u - discountAmt);
  };

  /* ------------------------------------------------------------------
   * Abschnitt 2: Form/Länge auf Slot-Kacheln
   * bkMediaBundleCountsToSlots baut die Slot-Datenobjekte, deren
   * productTitle 1:1 als Kachel-Titel gerendert wird. Wir hängen das
   * Meta (" · Medium Almond") idempotent an. Der Warenkorb nutzt nur
   * variantId und bleibt unberührt; der Vorschau-Streifen nutzt nur
   * das Bild.
   * ------------------------------------------------------------------ */
  var origCountsToSlots = window.bkMediaBundleCountsToSlots;
  if (typeof origCountsToSlots === 'function') {
    var ppMetaFromHandle = function (handle) {
      var h = String(handle || '').toLowerCase();
      if (!h) return '';
      var toks = h.split('-');
      var len = '';
      var shape = '';
      for (var i = 0; i < toks.length; i++) {
        var t = toks[i];
        if (t === 'short') {
          len = toks[i - 1] === 'extra' ? 'Extra Short' : 'Short';
        } else if (t === 'medium') {
          len = 'Medium';
        } else if (t === 'long') {
          len = toks[i - 1] === 'extra' ? 'Extra Long' : 'Long';
        } else if (t === 'almond') {
          shape = 'Almond';
        } else if (t === 'square') {
          shape = 'Square';
        } else if (t === 'round') {
          shape = 'Round';
        } else if (t === 'oval') {
          shape = 'Oval';
        } else if (t === 'coffin') {
          shape = 'Coffin';
        } else if (t === 'stiletto') {
          shape = 'Stiletto';
        }
      }
      return (len + ' ' + shape).replace(/^\s+|\s+$/g, '');
    };

    window.bkMediaBundleCountsToSlots = function (products, counts, slotCount) {
      var slots = origCountsToSlots(products, counts, slotCount);
      try {
        var metaByVid = {};
        (products || []).forEach(function (p) {
          if (!p || !Array.isArray(p.variants)) return;
          var meta = p.presson_meta != null && String(p.presson_meta).trim() !== ''
            ? String(p.presson_meta).trim()
            : ppMetaFromHandle(p.handle);
          if (!meta) return;
          p.variants.forEach(function (v) {
            v && v.id != null && (metaByVid[String(v.id)] = meta);
          });
        });
        slots.forEach(function (s) {
          if (!s || !s.variantId) return;
          var m = metaByVid[String(s.variantId)];
          if (!m) return;
          var base = s.productTitle || s.title || '';
          if (base.indexOf(m) !== -1) return;
          s.productTitle = (base ? base + ' \u00b7 ' : '') + m;
        });
      } catch (e) {}
      return slots;
    };
  }
})();

/* ------------------------------------------------------------------
 * Abschnitt 3: Slot-Stückpreis nur für echte Zusatzdesigns
 * ------------------------------------------------------------------
 * Bugfix: bkMediaBundleSlotShouldShowSlotPrice markiert im
 * gratis-Layout Positionen ZWISCHEN den Preset-Tiers statisch als
 * "Extra" (> tier2Qty && < tier3Qty — bei 2/4/6 also genau
 * Position 5) und blendet dort den Einzel-Stückpreis ein, auch wenn
 * der gewählte Tier die Position längst einschließt (6/6-Set nach
 * Auto-Advance: "Set bereit", aber Slot 5 zeigt 11,20 € / 16,00 €).
 *
 * Korrektur: Liegt die Design-Position innerhalb des aktuell
 * gewählten Tiers (position <= tierQty), gehört sie zum Set-Preis
 * und bekommt keinen Einzelpreis. Positionen oberhalb des gewählten
 * Tiers (5. Design bei 4er-Set) delegieren unverändert an das
 * Original — die gewollte Aufpreis-Anzeige bleibt erhalten.
 * ------------------------------------------------------------------ */
(function () {
  var origShouldShow = window.bkMediaBundleSlotShouldShowSlotPrice;
  if (typeof origShouldShow !== 'function') return;

  function isPressOnLadder(cfg) {
    if (!cfg || cfg.gratisStarterLadder !== true) return false;
    return String(cfg.bundleGroup || '').indexOf('presson') !== -1;
  }

  window.bkMediaBundleSlotShouldShowSlotPrice = function (
    slotIndex, totalSlots, priceQty, tierQty, cfg, filledCount, isOptionalDesignSlot, bundleRoot
  ) {
    if (isPressOnLadder(cfg) && (cfg.slotBadgeLayout || 'percentage') === 'gratis') {
      var filled = typeof filledCount === 'number' ? filledCount : 0;
      var pos = isOptionalDesignSlot === true
        ? Math.max(1, filled + 1)
        : (typeof priceQty === 'number' ? priceQty : Number(priceQty) || 0);
      var tq = Math.floor(Number(tierQty) || 0);
      if (tq > 0 && pos >= 1 && pos <= tq) return false;
    }
    return origShouldShow.apply(null, arguments);
  };
})();

/* ------------------------------------------------------------------
 * Abschnitt 4: Klaviyo BIS Auto-Open (Deep-Link von der Collection)
 * ------------------------------------------------------------------
 * Der "Benachrichtigen"-Button auf den Collection-Karten fuehrt auf die
 * PDP mit ?bis=1. Hier wird dann automatisch der Klaviyo-BIS-Trigger
 * geklickt -> das Popup oeffnet sich, als haette der Kunde den PDP-
 * Button gedrueckt. ?bis=1 wird danach aus der URL entfernt (kein
 * erneutes Oeffnen bei Reload/Zurueck). Ohne ?bis=1 passiert nichts.
 *
 * Bevorzugt Klaviyos gerenderten Button (kl-private-reset-css); faellt
 * auf das theme-seitige klaviyo-bis-trigger-Element zurueck. Klickt
 * hoechstens ~1x/900ms und stoppt, sobald das BIS-Formular (E-Mail-Feld)
 * offen ist - so wird nichts wieder zugeklickt.
 * ------------------------------------------------------------------ */
(function () {
  if (!/[?&]bis=1(&|$)/.test(window.location.search || '')) return;

  /* Klaviyos gerenderter BIS-Button (erscheint, sobald Klaviyo den
     PDP-Trigger verarbeitet hat) - das ist der zuverlaessige Oeffner. */
  function klButton() {
    return document.querySelector('button[class*="kl-private-reset-css"]');
  }
  function popupOpen() {
    return !!document.querySelector(
      '[class*="kl-private-reset-css"] input[type="email"], ' +
      '[class*="klaviyo-form"] input[type="email"]'
    );
  }
  function cleanUrl() {
    try {
      history.replaceState({}, document.title,
        window.location.pathname + (window.location.hash || ''));
    } catch (e) {}
  }

  /* Schnell pollen (100ms) und sofort starten, damit sich das Popup als
     Vollbild-Overlay ueber den Button legt, waehrend dieser im Hintergrund
     von "Ausverkauft" auf Klaviyos Label wechselt. popupOpen() wird VOR
     jedem Klick geprueft -> kein Zuklicken eines offenen Formulars. */
  var tries = 0, MAX = 60, lastClick = 0;
  function tick() {
    tries++;
    if (popupOpen()) { cleanUrl(); return; }
    var b = klButton();
    if (b && Date.now() - lastClick > 500) {
      try { b.click(); } catch (e) {}
      lastClick = Date.now();
    }
    if (tries < MAX) {
      setTimeout(tick, 100);
    } else {
      cleanUrl();
    }
  }
  tick();
})();

/* ------------------------------------------------------------------
 * Abschnitt 5: Collection "Ausverkauft" -> "Benachrichtigen"
 * ------------------------------------------------------------------
 * Auf Collection-/Grid-Karten wird der deaktivierte "Ausverkauft"-
 * Button durch einen "Benachrichtigen"-Link ersetzt, der auf die PDP
 * mit ?bis=1 fuehrt. Dort oeffnet Abschnitt 4 automatisch das Klaviyo-
 * BIS-Popup - genau wie ein Klick auf den PDP-Button.
 *
 * Gleiche Button-Optik (Klassen werden uebernommen). Ajax-nachgeladene
 * Karten (Filter/Paginierung/Section-Reload) werden per Observer
 * nachgezogen. Betrifft nur Karten (.product-card__add-to-cart), nicht
 * die PDP oder den Cart-Drawer.
 * ------------------------------------------------------------------ */
(function () {
  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var btns = scope.querySelectorAll(
      '.product-card__add-to-cart button[disabled]:not([data-pp-bis-card])'
    );
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      btn.setAttribute('data-pp-bis-card', '1');
      var card = btn.closest('product-card, .product-card');
      var link = card && card.querySelector('a.product-card__info-link, a[href*="/products/"]');
      var url = link ? link.getAttribute('href') : null;
      if (!url && card && card.getAttribute('handle')) {
        url = '/products/' + card.getAttribute('handle');
      }
      if (!url) continue;
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      var a = document.createElement('a');
      a.className = btn.className;
      a.setAttribute('href', url + sep + 'bis=1');
      a.setAttribute('data-instant', '');
      a.setAttribute('aria-label', 'Benachrichtigen');
      a.innerHTML = '<div>Benachrichtigen</div>';
      if (btn.parentNode) btn.parentNode.replaceChild(a, btn);
    }
  }

  function run() { enhance(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  if (typeof MutationObserver !== 'undefined' && document.body) {
    var raf = 0;
    new MutationObserver(function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        enhance(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
